import 'antd/dist/reset.css'
import './assets/less/giro-theme.less'
import {Layout} from "antd";
import {BrowserRouter} from "react-router-dom";
import Header from "./components/layout/Header";
import React, {useEffect} from "react";
import {Content} from "antd/es/layout/layout";
import {useAppDispatch, useAppSelector} from "./hooks/hooks";
import SessionWarning from "./components/auth/SessionWarning";
import {validateSession} from "./store/slices/SessionSlice";
import {redirectToKeycloakLogin} from "./utils/keycloak";
import AppRouter from "./routes/AppRouter";
import {QueryProvider} from "./providers/QueryProvider";
import GiroSpin from "./components/common/GiroSpin";
import {AntdConfigProvider} from "./providers/AntdConfigProvider";
import Sidebar from "./components/layout/Sidebar";
import {SearchProvider} from "./contexts/SearchContext";
import {BreadcrumbProvider} from "./contexts/BreadcrumbContext";
import {useTranslation} from "./hooks/useTranslation";

const MainLayout: React.FC = () => {
  const hideNavBar = useAppSelector((state) => state.ui.hideNavBar);
  const showNav = !hideNavBar;

  return (
    <Layout style={{height: '100vh'}} hasSider={showNav}>
      {showNav && <Sidebar/>}
      <Layout style={{flex: 1, minHeight: 0, minWidth: 0}}>
        <Header/>
        <Content
          className={"gt-content-main"}
          style={{flex: 1, minHeight: 0, minWidth: 0, overflow: 'auto', padding: 0}}
        >
          <AppRouter/>
        </Content>
      </Layout>
    </Layout>
  );
};

function App() {
  const {loading} = useAppSelector((state) => state.session)
  const dispatch = useAppDispatch();
  const {t} = useTranslation();

  useEffect(() => {
    const initSession = async () => {

      const result = await dispatch(validateSession());

      if (validateSession.rejected.match(result)) {
        const payload = result.payload as any;
        if (payload?.type === 'NO_COOKIE' || payload?.type === 'SESSION_INVALID') {
          redirectToKeycloakLogin();
        }
      }
    };

    initSession().catch((error) => {
      console.error('Error initializing session:', error);
    });
  }, [dispatch]);


  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <GiroSpin tip={t('messages.loading')} animationType={"circle"}/>
      </div>
    );
  }

  return (
    <AntdConfigProvider>
      <QueryProvider>
        <BrowserRouter>
          <SearchProvider>
            <BreadcrumbProvider>
              <SessionWarning/>
              <MainLayout/>
            </BreadcrumbProvider>
          </SearchProvider>
        </BrowserRouter>
      </QueryProvider>
    </AntdConfigProvider>
  );
};

export default App
